
  window.Shoppad = window.Shoppad || {},
  window.Shoppad.apps = window.Shoppad.apps || {},
  window.Shoppad.apps.infiniteoptions = {
    ready: function() {

      function callback() {
        $('#infiniteoptions-container .datepicker').datepicker({
          inline: true,
          minDate:1,
          maxDate: 60,
          beforeShowDay: function(date) {
            var unavailableDayMonthYear = [

              ["1-5-2021", "Closed"],
              ["2-5-2021", "Closed"],
              ["8-5-2021", "Closed"],
              ["15-5-2021", "Closed"],
              ["16-5-2021", "Closed"],
              ["22-5-2021", "Closed"],
              ["23-5-2021", "Closed"],
              ["29-5-2021", "Closed"],
              ["30-5-2021", "Closed"],
              ["25-12-2021", "Christmas Day"],
              ["26-12-2021", "Boxing Day"]

            ];

            return function (date) {
              var dayMonthYear = (date.getDate() + "-" + (date.getMonth()+1) + "-" + date.getFullYear());
              var now = new Date();

              
              // ** TURN THIS BACK ON AFTER MOTHERS DAY - START **
              
              // Prevent deliveries for weekends
               if (date.getDay() == 0 || date.getDay() == 6) {
                return [false, '','No deliveries on weekends'];
              }
              
              // ** TURN THIS BACK ON AFTER MOTHERS DAY - END **

              

              // Prevent orders on weekends / after 2pm the Friday before
              //if (date.getDay() == 0 || date.getDay() == 6) {

               // Subtract 2 days from Sunday or 1 day from Saturday to get the Friday before
               //twoPmFriBefore.setDate((date.getDay() == 0) ? (date.getDate() - 2) : (date.getDate() - 1));       //FOR FRIDAY
               //var twoPmFriBefore = new Date(date.getTime());
               //twoPmFriBefore.setDate((date.getDay() == 0) ? (date.getDate() - 1) : (date.getDate() - 1));         //FOR SATURDAY
               //twoPmFriBefore.setHours(14); //2pm

               //console.log("DATE: " + date + ", 2PM FRI BEFORE: " + twoPmFriBefore + ", NOW: " + now);

               //if (now > twoPmFriBefore) {
               //    return [false, '', 'Weekend orders must be placed before 2pm Friday'];
               // }
              //}

              // Prevent next day orders after 12pm
              if (date.getFullYear() == now.getFullYear() &&
                  date.getMonth() == now.getMonth() &&
                  date.getDate() == now.getDate() &&
                  now.getHours() >= 12) { // 12pm day before cutoff
               return [false, '', 'Past 12pm cutoff - please give us a call'];
              }

              // Prevent orders on public holidays
              var i;
              for (i = 0; i < unavailableDayMonthYear.length; i += 1) {
                if (unavailableDayMonthYear[i][0] == dayMonthYear) {
                  return [false, '', unavailableDayMonthYear[i][1]];
                }

              };
              return [true]; //Enabled by default
            }(date)
			},

          altField: '#infiniteoptions-container .datepicker input[type=text]',
          altFormat: "dd-mm-yy",
          onSelect: function() {
            $('#infiniteoptions-container .ui-datepicker-inline').hide();
          }
        });

        $('#infiniteoptions-container .datepicker input[type=text]').change(function(){
          $('#infiniteoptions-container .datepicker').datepicker('setDate', $(this).val());
        });

        $('#infiniteoptions-container .datepicker').datepicker( "setDate", '' );

        $('#infiniteoptions-container .datepicker input[type=text]').attr('readonly','true');

        $('#infiniteoptions-container .ui-datepicker-inline').hide();

        $('#infiniteoptions-container .datepicker input[type=text]').on('click touchstart', function (e) {
              $('#infiniteoptions-container .ui-datepicker-inline').show();
        });
      }

      $(document).on('mouseup touchstart', function(e) {
        var isDatePickerInput = $('#infiniteoptions-container .datepicker input').is(e.target);
        var isDatePicker = $('#infiniteoptions-container .ui-datepicker-inline').is(e.target);
        var isChildOfDatePicker = $('#infiniteoptions-container .ui-datepicker-inline').has(e.target).length;

        // If the target of the click isn't the text input, the date picker, or a descendant of the date picker
        if (!isDatePickerInput && !isDatePicker && !isChildOfDatePicker) {
          $('#infiniteoptions-container .ui-datepicker-inline').hide();
        }
      });

      if (window.jQuery.fn.datepicker) {
        callback();
      } else {
        var script = document.createElement('script');
        script.src = '//code.jquery.com/ui/1.10.2/jquery-ui.js';
        script.onload = callback;
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    }
  };
